import React from 'react';

const DurationComponent = ({ className, seconds }) => {
  function pad(string) {
    return ('0' + string).slice(-2);
  }
  const format = (seconds) => {
    if (seconds) {
      const hh = Math.floor(seconds / 3600);
      const mm = Math.floor(seconds / 60) - hh * 60;
      const ss = Math.floor(seconds % 60);
      if (hh) {
        return `${hh}:${pad(mm)}:${pad(ss)}`;
      }
      return `${pad(mm)}:${pad(ss)}`;
    }
    return '00:00';
  };

  return (
    <time dateTime={`P${Math.round(seconds)}S`} className={className}>
      {format(seconds)}
    </time>
  );
};

export default DurationComponent;
